import { render, staticRenderFns } from "./ProjectLiveTalk.vue?vue&type=template&id=2a9b3078&"
import script from "./ProjectLiveTalk.vue?vue&type=script&lang=ts&"
export * from "./ProjectLiveTalk.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports